module.exports = __webpack_public_path__ + "static/media/profile.58ad7480.png";